import React from "react"; 
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery"; 
import "../WmsDashboard.css";
 
import Modal from "@mui/material/Modal"; 
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
 
const GCModal= ({
  xOpen = false,
  fCloseModal,   
  xTitle = "",  
  component
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");   
  return (
    <Modal
      open={xOpen}
      onClose={fCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
        gnr-item-search 
        GC-model"
      >
         
        <GCTitleSticky title={xTitle} onClose={fCloseModal} />
        
        <div className="p-2">
          {component}
          
        </div>
      </Box>
    </Modal>
  );
};

export default GCModal;
